import React from 'react';

import { Menu, Typography, Dropdown } from 'antd';
import PropTypes from 'prop-types';

import {
  SafetyCertificateOutlined,
  SafetyCertificateFilled,
} from '@ant-design/icons';

import './ProductSubscription.less';

const { Text } = Typography;

const STATUS_MAP = {
  'subscribed': { colorClass: 'blue', tooltip: 'Subscribed' },
  'syndicated': { colorClass: 'green', tooltip: 'Syndicated' },
};

const ProductSubscription = ({ status, isFill, gdsnShield }) => {
  let statusKey = (status ?? '').toLowerCase();
  const gdsnShieldColour = (gdsnShield ?? '').toLowerCase();

  // When the product is received from GDSN (green shield) and it is subscribed,
  // promote the subscription shield to "Syndicated" (the GDSN shield is hidden).
  if (gdsnShieldColour === 'green' && statusKey === 'subscribed') {
    statusKey = 'syndicated';
  }

  // When the product is received from GDSN and modified (yellow shield) and it
  // is subscribed, hide the subscription shield — the yellow GDSN shield
  // represents it.
  if (gdsnShieldColour === 'yellow' && statusKey === 'subscribed') {
    return null;
  }

  const { colorClass = '', tooltip = '' } = STATUS_MAP[statusKey] || {};

  const overLay = (
    <Menu style={{ padding: 4, fontWeight: 900 }}>
      <Menu.Item>
        <Text strong>{tooltip}</Text>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className='pd-subscribe'>
      <Dropdown overlay={overLay} placement='bottomRight'>
        {isFill ? (
          <SafetyCertificateFilled
            className={`pd-subscribe__icon pd-subscribe__icon--` + colorClass}
          />
        ) : (
          <SafetyCertificateOutlined
            className={`pd-subscribe__icon pd-subscribe__icon--` + colorClass}
          />
        )}
      </Dropdown>
    </div>
  );
};

ProductSubscription.propTypes = {
  status: PropTypes.string,
  isFill: PropTypes.bool,
  gdsnShield: PropTypes.string,
};

export default ProductSubscription;
